import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChild, ElementRef, Input } from '@angular/core';
import { NOT_AVAILABLE, TRANSPORT_MODE_ICONS_MAP, TransportMode } from '../../common';

@Component({
  selector: 'ui-transport-mode',
  templateUrl: './transport-mode.component.html',
  styleUrls: ['./transport-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportModeComponent implements AfterContentInit {
  @Input() mode: TransportMode;
  @Input() showText = true;
  @Input() isNoteAvailableTitleVisible = true;
  @ContentChild('notAvailableTemplate', { static: false }) content!: ElementRef | undefined;

  transportMode = TransportMode;
  iconsMap = TRANSPORT_MODE_ICONS_MAP;
  notAvailable = NOT_AVAILABLE;
  hasProjectedContent = false;

  ngAfterContentInit(): void {
    this.hasProjectedContent = !!this.content;
  }
}
